<template>
  <div class="flex flex-row gap-2 items-center">
    <el-dropdown
      split-button
      type="primary"
      @click="handleClick"
      @command="handleCommand"
      :disabled="status === SpeechStatus.INVALID"
      :title="computedInvalidTip"
      :aria-label="computedInvalidTip"
    >
      <i
        :class="
          status === SpeechStatus.OFF
            ? 'fa fa-microphone'
            : status === SpeechStatus.ON
            ? 'fa fa-microphone text-red-500'
            : 'fa fa-microphone-slash text-gray-400'
        "
      />
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-for="item in langOptions"
          :key="item.value"
          :command="item.value"
          :selected="item.value === lang"
        >
          <span class="flex flex-row gap-4 items-center">
            {{ item.label }}
            <i v-if="item.value === lang" class="el-icon-check" style="color:#fcb900" />
          </span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
const SpeechStatus = {
  OFF: "off",
  ON: "on",
  INVALID: "invalid",
};

export default {
  name: "ButtonSpeech",
  emits: ["recognize"],
  data() {
    return {
      status: SpeechStatus.OFF,
      recognition: null,
      SpeechStatus,
      lang: navigator.language || navigator.userLanguage || "zh-CN",
      langOptions: [
        { label: "English", value: "en-US" },
        { label: "繁體中文", value: "zh-HK" },
        { label: "简体中文", value: "zh-CN" },
        { label: "日本語", value: "ja-JP" },
        { label: "한국어", value: "ko-KR" },
        { label: "Deutsch", value: "de-DE" },
        { label: "Français", value: "fr-FR" },
      ],
    };
  },
  watch: {
    lang(newLang) {
      if (this.recognition) {
        this.recognition.lang = newLang;
      }
    },
  },
  computed: {
    computedLang() {
      return this.lang;
    },
    computedInvalidTip() {
      const ua = navigator.userAgent;
      const isChrome = /Chrome/.test(ua) && !/Edge/.test(ua) && !/OPR/.test(ua);
      const isEdge = /Edg/.test(ua);
      const isSafari = /Safari/.test(ua) && !/Chrome/.test(ua);
      const isFireFox = /Firefox/.test(ua);
      const isOpera = /OPR/.test(ua);
      if (this.status !== SpeechStatus.INVALID) {
        return "Speech Recognition";
      }
      if (isFireFox) {
        return "Firefox speech recognition is not supported.";
      }
      if (isOpera) {
        return "Opera speech recognition is not supported.";
      }
      if (isChrome) {
        return "Currently unable to access Google. Chrome speech recognition is not supported in China.";
      }
      if (isEdge) {
        return "Edge speech recognition is supported in China.";
      }
      if (isSafari) {
        return "Safari speech recognition is supported in China.";
      }
      return "Speech recognition is not supported.";
    },
  },
  methods: {
    handleClick() {
      switch (this.status) {
        case SpeechStatus.OFF:
          if (this.recognition) this.recognition.start();
          this.status = SpeechStatus.ON;
          break;
        case SpeechStatus.ON:
          if (this.recognition) this.recognition.stop();
          this.status = SpeechStatus.OFF;
          break;
        case SpeechStatus.INVALID:
          break;
      }
    },
    handleCommand(langValue) {
      this.lang = langValue;
      if (this.recognition) {
        this.recognition.lang = langValue;
      }
    },
    async checkInvalid() {
      const ua = navigator.userAgent;
      const isChrome = /Chrome/.test(ua) && !/Edge/.test(ua) && !/OPR/.test(ua);
      const isEdge = /Edg/.test(ua);
      const isSafari = /Safari/.test(ua) && !/Chrome/.test(ua);
      const isFireFox = /Firefox/.test(ua);
      const isOpera = /OPR/.test(ua);
      // Firefox/Opera直接禁用
      if (isFireFox || isOpera) {
        this.status = SpeechStatus.INVALID;
        return;
      }
      // Edge/Safari直接可用
      if (isEdge || isSafari) {
        return;
      }
      // Chrome需检测Google
      if (isChrome) {
        const fetchPromise = fetch("https://www.google.com", {
          mode: "no-cors",
        });
        const timeoutPromise = new Promise((_, reject) => {
          setTimeout(() => reject(new Error("Fetch timeout")), 1000);
        });
        try {
          await Promise.race([fetchPromise, timeoutPromise]);
        } catch (error) {
          this.status = SpeechStatus.INVALID;
        }
      }
    },
  },
  mounted() {
    // 初始化语音识别实例及事件绑定
    const recognitionSupported = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (recognitionSupported) {
      this.recognition = new recognitionSupported();
      this.recognition.lang = this.lang;
      this.recognition.onresult = (event) => {
        const text = event.results[0][0].transcript;
        this.$emit("recognize", text);
      };
      this.recognition.onend = () => {
        this.status = SpeechStatus.OFF;
      };
      this.recognition.onerror = () => {
        this.status = SpeechStatus.INVALID;
      };
    } else {
      this.status = SpeechStatus.INVALID;
    }
    this.checkInvalid();
  },
};
</script>
